import { httpClient } from 'src/libraries/http.library';
import { RiskAssessmentPayloadSchema } from 'src/models/risk-assessment-key.model';

const client = httpClient();

const services = {
  listGET: async () => {
    return client.get('/assessmentKey', {}, RiskAssessmentPayloadSchema);
  },
};

export default services;
